<template>
  <transfer-list></transfer-list>
</template>

<script>

import TransferList from './../../../components/distributors/transfers/list.vue'
export default {
  data: () => ({
  }),
  metaInfo() {
    return {
      title: this.$t('distributors.transfers.title')
    }
  },
  components: {
    TransferList
  }
}
</script>